module.exports = __webpack_public_path__ + "img/BOTChallenge.10161b61.svg";